import { AppBar, styled } from '@mui/material';
import { forwardRef } from 'react';

const CustomAppBar = styled(AppBar)(({ theme }) => {
    return {
        top: 'auto',
        bottom: 0,
        borderTop: `1px solid ${theme.palette.ensightful.neutral[300]}`,
        borderRadius: 0,
        padding: theme.spacing(3, 7),
        background: theme.palette.ensightful.shades[0],
    };
});

const BottomBar = forwardRef(({ children, ...rest }, ref) => {
    return (
        <CustomAppBar ref={ref} {...rest} position={'fixed'}>
            {children}
        </CustomAppBar>
    );
});

export default BottomBar;
